import { useQuery } from '@tanstack/react-query';
import useUserProfile from './useUserProfile';
import { client } from '@util/getTypesense';
import { ProductDocument } from 'models/product';

export default function useSuggestedProducts() {
  const {
    data: { data: userProfile },
  } = useUserProfile();

  const { data: basedOnActivity } = useQuery({
    queryKey: ['basedOnActivity', userProfile?.uid],
    queryFn: async () => {
      // update firebase types to remove as any
      const vecQuery = `embedding:([${(
        userProfile?.activity_profile as any
      ).value.toString()}], k:100)`;

      let searchRequests = {
        searches: [
          {
            collection: 'products_alias',
            q: '*',
            vector_query: vecQuery,
            group_by: 'seller_id',
            group_limit: 1,
          },
        ],
      };

      const { results } = await client.multiSearch.perform<ProductDocument[]>(
        searchRequests,
        {
          exclude_fields: 'shipment',
        }
      );
      return (
        results[0].grouped_hits
          ?.map((h) => h.hits?.map((hh) => hh.document as ProductDocument))
          .flat()
          .slice(0, 10) ?? []
      );
    },
    enabled: !!userProfile?.uid,
    throwOnError: false,
  });

  return {
    basedOnActivity,
  };
}
